import React from 'react';
import './OptimalHealthPath.css';

function OptimalHealthPath({ onCtaClick }) {
  return (
    <section className="ttc-path-main-wrapper position-relative py-5">
      <div 
        className="ttc-path-bg-image" 
        style={{ backgroundImage: `url('/images/creatives/lnading-card-grid.jpg')` }}
      />
      <div className="ttc-path-bg-overlay" />

      <div className="container position-relative ttc-path-content-layer py-lg-4">
        
        <div className="row align-items-center mb-5 gy-3">
          <div className="col-12 col-lg-7">
            <h2 className="ttc-path-heading text-white mb-0">
              A Clear Path Toward <br />
              <span className="ttc-path-heading-italic">Your Optimal Health</span>
            </h2>
          </div>
          <div className="col-12 col-lg-5">
            <p className="ttc-path-subheading mb-0">
              Our Program Follows A Step-By-Step, Data-Driven Methodology To Create Lasting Transformation In Your Health And Well-Being.
            </p>
          </div>
        </div>

        <div className="row g-4">
          <div className="col-12 col-md-6 col-lg-4">
            <div className="ttc-path-card h-100">
              <span className="ttc-path-step-label">Step 1</span>
              <h3 className="ttc-path-card-title mt-2 mb-3">
                Comprehensive Medical <br />
                <span className="ttc-path-serif-text">History Collection</span>
              </h3>
              <p className="ttc-path-card-desc mb-0">
                We Begin By Understanding Your Personal And Family Medical History To Establish A Strong Clinical Foundation.
              </p>
            </div>
          </div>

          <div className="col-12 col-md-6 col-lg-4">
            <div className="ttc-path-card h-100">
              <span className="ttc-path-step-label">Step 2</span>
              <h3 className="ttc-path-card-title mt-2 mb-3">
                Multidisciplinary Health <br />
                <span className="ttc-path-serif-text">Assessments</span>
              </h3>
              <p className="ttc-path-card-subtitle mb-2">Our Executive Assessment Includes:</p>
              <div className="row g-1 ttc-path-assessment-list">
                <div className="col-6">• Executive Medical</div>
                <div className="col-6">• Fitness And Physiology</div>
                <div className="col-6">• Stress And Wellness</div>
                <div className="col-6">• Women's And Men's Health</div>
                <div className="col-6">• Cardiovascular Risk</div>
                <div className="col-6">• Naturopathic Assessment</div>
                <div className="col-6">• Nutrition</div>
                <div className="col-6">• Cancer Risk</div>
              </div>
            </div>
          </div>

          <div className="col-12 col-md-6 col-lg-4">
            <div className="ttc-path-card h-100">
              <span className="ttc-path-step-label">Step 3</span>
              <h3 className="ttc-path-card-title mt-2 mb-3">
                Personalized <br />
                <span className="ttc-path-serif-text">Health Strategy</span>
              </h3>
              <p className="ttc-path-card-desc mb-0">
                Your Results Are Reviewed And Synthesized Into A Tailored Health Action Plan, Focusing On Both Risk Mitigation And Health Optimization.
              </p>
            </div>
          </div>

          <div className="col-12 col-md-6 col-lg-4">
            <div className="ttc-path-card h-100">
              <span className="ttc-path-step-label">Step 4</span>
              <h3 className="ttc-path-card-title mt-2 mb-3">
                Ongoing Care And <br />
                <span className="ttc-path-serif-text">Monitoring</span>
              </h3>
              <p className="ttc-path-card-desc mb-0">
                Through Monthly Follow-Ups, Our Clinical Team Proactively Manages Your Care, Adjusting For Any Changes And Helping You Stay Accountable To Your Goals.
              </p>
            </div>
          </div>

          <div className="col-12 col-md-6 col-lg-4">
            <div className="ttc-path-card h-100">
              <span className="ttc-path-step-label">Step 5</span>
              <h3 className="ttc-path-card-title mt-2 mb-3">
                24/7 Access And <br />
                <span className="ttc-path-serif-text">Continuous Support</span>
              </h3>
              <p className="ttc-path-card-desc mb-0">
                From Prescription Renewals To Acute Concerns And Health Navigation Abroad, You're Never On Your Own.
              </p>
            </div>
          </div>

          <div className="col-12 col-md-6 col-lg-4">
            <div className="ttc-path-card h-100 d-flex flex-column justify-content-between">
              <div>
                <span className="ttc-path-step-label text-primary">Last Step</span>
                <h3 className="ttc-path-card-title mt-2 mb-3 ">
                  Curious To Learn More?
                </h3>
                <p className="ttc-path-card-desc mb-4">
                  Want To Better Understand Our Program? Book A Call With Our Team To Get All Your Questions Answered. You Can Also Download Our Prevention Booklet To Explore How We Help Clients Stay At Their Best Year After Year.
                </p>
              </div>

              <div>
                <button 
                  type="button" 
                  onClick={onCtaClick}
                  className="btn ttc-path-btn-primary d-inline-flex align-items-center gap-2"
                >
                  <span>Book A Consultation</span>
                  <span className="ttc-path-btn-icon">↗</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default OptimalHealthPath;